import axios from 'axios';

export default {
  namespaced: true,

  state: {
    countries: [],
    citizenships: []
  },

  getters: {
    getCountries(state) {
      return state.countries;
    },
    getCitizenships(state) {
      return state.citizenships;
    }
  },

  mutations: {
    SET_COUNTRIES(state, value) {
      state.countries = value;
    },
    SET_CITIZENSHIPS(state, value) {
      state.citizenships = value;
    }
  },

  actions: {
    getCountriesData({ commit }) {
      axios.get('/api/countries').then(res => {
        const countries = res.data.data;
        commit('SET_COUNTRIES', countries);
      });
    },
    getCitizenshipsData({ commit }) {
      axios.get('/api/citizenships').then(res => {
        const citizenships = res.data.data;
        commit('SET_CITIZENSHIPS', citizenships);
      });
    }
  }
};
